import {
  ArrowLeftRight,
  BarChart3,
  BookOpen,
  Brain,
  Calculator,
  FileSearch,
  FileText,
  Hand,
  Handshake,
  LayoutDashboard,
  Puzzle,
  Settings,
  ShieldCheck,
  Target,
  Users,
  Waypoints,
  type LucideIcon
} from 'lucide-react';

/**
 * Maps kebab-case icon names from app manifests to Lucide icon components.
 * Only includes icons likely to be used by apps — extend as needed.
 */
const ICON_MAP: Record<string, LucideIcon> = {
  'arrow-left-right': ArrowLeftRight,
  'bar-chart': BarChart3,
  'book-open': BookOpen,
  'chart-bar': BarChart3,
  brain: Brain,
  calculator: Calculator,
  'file-search': FileSearch,
  'file-text': FileText,
  dashboard: LayoutDashboard,
  hand: Hand,
  handshake: Handshake,
  puzzle: Puzzle,
  settings: Settings,
  'shield-check': ShieldCheck,
  target: Target,
  users: Users,
  waypoints: Waypoints
};

const FALLBACK_ICON: LucideIcon = Puzzle;

export function resolveAppIcon(iconName?: string): LucideIcon {
  if (!iconName) return FALLBACK_ICON;
  return ICON_MAP[iconName] ?? FALLBACK_ICON;
}
